module.exports = __webpack_public_path__ + "img/97.9164c916.jpg";